export default "__VITE_ASSET__B$atUbNX__"